import { getReturnReasons } from "@/api/returnReasons.js";

const getDefaultState = () => {
  return {
    returnReasons: [],
    returnReasonsLoading: true,

    pagination: {
      pageList: {
        active: false,
        pages: [],
      },
      currentPage: 1,
      lastPage: 0,
    },
  };
};

export default {
  namespaced: true,
  state: getDefaultState(),
  actions: {
    getReturnReasons({ commit, state }, params, perPage = 10, currentPage = 1) {
      const sort = params?.sort || "id";
      const search = params?.search || "";
      commit("SET_REASONS_LOADING", true);
      currentPage = state.pagination.currentPage;
      getReturnReasons(perPage, currentPage, sort, search)
        .then((res) => {
          commit("SET_REASONS", res.data);
        })
        .finally(() => commit("SET_REASONS_LOADING", false));
    },
    clearData({ commit }) {
      commit("INIT_STATE");
    },
    // pagination
    getReturnReasonsListPage({ commit, dispatch }, params) {
      commit("SET_CURRENT_PAGE", params.page);
      dispatch("getReturnReasons", params);
    },
  },
  mutations: {
    SET_REASONS(state, reasons) {
      state.returnReasons = reasons;
    },
    ADD_REASON(state, reason) {
      state.returnReasons.push(reason);
    },
    SET_REASONS_LOADING(state, loading) {
      state.returnReasonsLoading = loading;
    },
    INIT_STATE(state) {
      Object.assign(state, getDefaultState());
    },
    RESET_REASONS_LIST_CURRENT_PAGE: (state) => {
      state.pagination.currentPage = 1;
    },
    SET_CURRENT_PAGE: (state, pageNum) => {
      state.pagination.currentPage = pageNum;
    },
  },
};
